import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { GameProvider } from './contexts/GameContext.tsx';
import { PortfolioProvider } from './contexts/PortfolioContext.tsx';
import Navigation from './components/Navigation.tsx';
import ScrollToTop from './components/ScrollToTop.tsx';
import Home from './pages/Home.tsx';
import SurvivalGame from './pages/survival/SurvivalGame.tsx';
import SurvivalLeaderboard from './pages/survival/SurvivalLeaderboard.tsx';
import PortfolioGame from './pages/portfolio/PortfolioGame.tsx';
import PortfolioLeaderboard from './pages/portfolio/PortfolioLeaderboard.tsx';
import { FIRESWEEPER_CONTAINER, FIRESWEEPER_SURVIVOR } from './constants/gameModes.ts';

function AppLayout() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isGame =
    location.pathname === FIRESWEEPER_CONTAINER.path ||
    location.pathname === FIRESWEEPER_SURVIVOR.path;

  const mainClass = [isHome && 'main--home', isGame && 'main--game'].filter(Boolean).join(' ') || undefined;

  return (
    <div className="app-shell">
      <Navigation />
      <main className={mainClass}>
        <Routes>
                <Route path="/" element={<Home />} />

                <Route path={FIRESWEEPER_CONTAINER.path} element={<SurvivalGame />} />
                <Route
                  path={FIRESWEEPER_CONTAINER.resultPath}
                  element={<Navigate to={FIRESWEEPER_CONTAINER.leaderboardPath} replace />}
                />
                <Route path={FIRESWEEPER_CONTAINER.leaderboardPath} element={<SurvivalLeaderboard />} />

                <Route path={FIRESWEEPER_SURVIVOR.path} element={<PortfolioGame />} />
                <Route
                  path={FIRESWEEPER_SURVIVOR.resultPath}
                  element={<Navigate to={FIRESWEEPER_SURVIVOR.leaderboardPath} replace />}
                />
                <Route path={FIRESWEEPER_SURVIVOR.leaderboardPath} element={<PortfolioLeaderboard />} />

                {/* Legacy redirects */}
                <Route path="/survival" element={<Navigate to={FIRESWEEPER_CONTAINER.path} replace />} />
                <Route path="/survival/result" element={<Navigate to={FIRESWEEPER_CONTAINER.leaderboardPath} replace />} />
                <Route path="/survival/leaderboard" element={<Navigate to={FIRESWEEPER_CONTAINER.leaderboardPath} replace />} />
                <Route path="/still-standing" element={<Navigate to={FIRESWEEPER_SURVIVOR.path} replace />} />
                <Route path="/still-standing/result" element={<Navigate to={FIRESWEEPER_SURVIVOR.leaderboardPath} replace />} />
                <Route path="/still-standing/leaderboard" element={<Navigate to={FIRESWEEPER_SURVIVOR.leaderboardPath} replace />} />
                <Route path="/portfolio" element={<Navigate to={FIRESWEEPER_SURVIVOR.path} replace />} />
                <Route path="/portfolio/result" element={<Navigate to={FIRESWEEPER_SURVIVOR.leaderboardPath} replace />} />
                <Route path="/portfolio/leaderboard" element={<Navigate to={FIRESWEEPER_SURVIVOR.leaderboardPath} replace />} />
                <Route path="/game" element={<Navigate to={FIRESWEEPER_CONTAINER.path} replace />} />
                <Route path="/game-result" element={<Navigate to={FIRESWEEPER_CONTAINER.leaderboardPath} replace />} />
                <Route path="/config" element={<Navigate to="/" replace />} />
                <Route path="/leaderboard" element={<Navigate to={FIRESWEEPER_CONTAINER.leaderboardPath} replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <GameProvider>
        <PortfolioProvider>
          <ScrollToTop />
          <AppLayout />
        </PortfolioProvider>
      </GameProvider>
    </BrowserRouter>
  );
}
